import { useMenu } from "@/shared/menu/useMenu";
import { Button, Result } from "antd";
import { useNavigate } from "react-router";

export function NotFound() {
  const navigate = useNavigate();
  const { atualizarMenuSelected } = useMenu();

  return (
    <Result
      status="404"
      title="404"
      subTitle="Desculpe mas essa pagina não existe."
      extra={
        <Button
          type="primary"
          onClick={() => {
            navigate("/");
            atualizarMenuSelected(["inicio"]);
          }}
        >
          Ir para pagina inicial
        </Button>
      }
    />
  );
}
